class SupplyChainSwiper extends HTMLElement {
    connectedCallback() {
        const _this = this;
        function init() {
            const container = _this.querySelector('.supplychain__swiper');
            if (!container) return;

            // 避免重复初始化
            if (container.swiper) container.swiper.destroy(true, true);

            new Swiper(container, {
                speed: 500,
                spaceBetween: 20,
                grabCursor: true,
                watchOverflow: true,
                navigation: {
                    nextEl: _this.querySelector('.swiper-button-next'),
                    prevEl: _this.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    0: { slidesPerView: 1.4, spaceBetween: 12 },
                    640: { slidesPerView: 2, spaceBetween: 16 },
                    1024: { slidesPerView: 2.4, spaceBetween: 20 },
                    1920: { slidesPerView: 4, spaceBetween: 20 }
                }
            });
        }

        // 首次与编辑器热加载
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
        document.addEventListener('shopify:section:load', function (e) {
            if (e && e.detail && e.detail.sectionId === SID) init();
        });
    }
}


// 注册自定义元素
reg("supply-chain-swiper", SupplyChainSwiper);